import React from "react";
import "./index.scss";
import config from "@/config";

import { connect } from "react-redux";
const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});

const DriverRules = (props) => {
  let cxname = config.TITLE

  return (
    <div className="driver_rules">
        <div className="text__show">
          <h2>司机行为规范及处罚规定</h2>
          <div class="ne-viewer-body">
              <div className="tips">
                为创建更加规范有序、公平合理的平台环境，助理网约车行业健康可持续发展，我们推出《司机违规行为及处罚规则》，请司机师傅们遵守，共同维护网约车行业的荣誉和口碑，让网约车成为文明城市的“流动名片”让乘客爱上网约车出行。
              </div>
            <br />
            <div className="title2">
              <span>1.司机恶意绕路</span>
            </div>
            <p>
              <div>
                未经乘客同意，未按照导航规划路线，导致实际行驶里程高于导航预估里程≥3公里。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>2.提前开始计费/延迟结束订单</span>
              <br />
            </div>
            <p>
              <div>
                乘客未上车提前开启计费、接错人导致订单产生费用、乘客下车延迟结束订单。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>3.乱添加附加费</span>
            </div>
            <p>
              <div>多收高速费、停车费、路桥费，无理由随意乱添加附加费。</div>
              <br />
            </p>

              <div className="tips">
                以上行为一经查实根据1周内出现的此处给予以下罚款，1周内出现1次，罚款10元；1周内出现2次，罚款50元；1周内出现3次，罚款100元；1周内出现3次以上，罚款300元；
              </div>
              <br />

            <div className="title2">
              <span>1.要求线下支付车费</span>
            </div>
            <p>
              <div>
                引导或者要求乘客通过非{cxname}线上支付方式进行支付车费（如：微信转账、支付宝、现金付款等）
              </div>
              <br />
            </p>
            <div className="title2">
              <span>2.服务态度恶劣</span>
            </div>
            <p>
              <div>对乘客出现言语不礼貌的行为，语气强硬或态度恶劣等。</div>
              <br />
            </p>
            <div className="title2">
              <span>3.未将乘客送达目的地</span>
            </div>
            <p>
              <div>未经乘客同意，将乘客放在非订单目的地位置。</div>
              <br />
            </p>
            <div className="title2">
              <span>4.未按约定时间接送乘客</span>
            </div>
            <p>
              <div>接单后，未能按照约定时间，到达约定地点，导致订单取消。</div>
              <br />
            </p>
            <div className="title2">
              <span>5.未配合乘客归还遗失物品</span>
            </div>
            <p>
              <div>
                乘客物品遗失在车内，未配合寻找/物品在车内索要往返车费的2倍以上费用。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>6.未经乘客同意擅自拼客</span>
            </div>
            <p>
              <div>行程进行期间通过其他手段同时接送其他乘客。</div>
              <br />
            </p>
            <div className="title2">
              <span>7.诱导乘客取消订单</span>
            </div>
            <p>
              <div>通过各种方式诱导乘客取消订单。</div>
              <br />
            </p>
            <div className="title2">
              <span>8.乱添加附加费</span>
            </div>
            <p>
              <div>多收高速费，停车费、路桥费，无理由随意乱添加附加费。</div>
              <br />
            </p>
            <div className="title2">
              <span>9.乱添加附加费</span>
            </div>
            <p>
              <div>多收高速费，停车费、路桥费，无理由随意乱添加附加费。</div>
              <br />
            </p>

              <div className="tips">
                以上行为一经查实封禁账号3天。
              </div>
              <br />

            <div className="title2">
              <span>1.言语肢体骚扰</span>
            </div>
            <p>
              <div>通过短信/肢体对乘客进行言语，肢体性骚扰。</div>
              <br />
            </p>

            <div className="title2">
              <span>2.人车不符</span>
            </div>
            <p>
              <div>接驾司机或车辆与平台注册接单信息不符。</div>
              <br />
            </p>

              <div className="tips">
                以上行为一经查实封禁账号7天。
              </div>
              <br />

            <div className="title2">
              <span>1.危险驾驶</span>
            </div>
            <p>
              <div>
                接单过程中，有酒驾或醉驾，超速行驶，飙车或其他危险驾驶情况。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>2.使用虚假证件</span>
            </div>
            <p>
              <div>
                使用虚假证件（包含身份证、驾驶证、行驶证、网约车驾驶证、车辆营运许可证）提交资料注册平台账号从事营运活动。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>3.侵犯乘客人身权利</span>
            </div>
            <p>
              <div>侵犯乘客人身权利等违法行为（骚扰、恐吓、威胁乘客等）。</div>
              <br />
            </p>
            <div className="title2">
              <span>4.拾得乘客财务拒绝归还</span>
            </div>
            <p>
              <div>
                拾得乘客财务拒绝归还或归还时所要不合理费用等不当得利行为。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>5.组织群体扰乱平台&amp;社会秩序</span>
            </div>
            <p>
              <div>
                通过组织群体聚集或发布不正当言论，扰乱平台秩序或社会治安。
              </div>
              <br />
            </p>
            <div className="title2">
              <span>6.违反交通规则驾驶</span>
            </div>
            <p>
              <div>违反交通规则驾驶（酒驾、毒驾、超速、超载等）。</div>
              <br />
            </p>
              <div className="tips">
                以上行为一经查实将对账号进行永久封禁。
              </div>
              <br />

            <h3>作弊行为</h3>
            <div className="text">所有通过不正当手段完成虚假订单来通套取补贴或垫付的行为。</div>

              <div className="tips">
                将扣除所有非法所得，并根据情节给予罚款及封禁处理，通过不正当手段完成虚假订单的行为{cxname}有权追究其法律责任。
              </div>
              <br />
            <div>
              如对处罚有异议，可以申诉或拨打客服热线：4000201666。本管理规定，自发布之日开始执行，最终解释权归{cxname}所有。
            </div>
          </div>
      </div>
      {/* <iframe className="iframe" src="//player.bilibili.com/player.html?aid=552153805&bvid=BV17i4y1C7es&cid=547357807&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> */}
    </div>
  );
};
export default connect(mapStateToProps)(DriverRules);
